// TODO: CONVERT TO TYPESCRIPT
import React from 'react'
import PropTypes from 'prop-types'
import { api } from 'components/api'
import { commodityCodeSearchPath } from 'components/routes/api'

export default class SearchBar extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      searchTerm: '',
      searchResults: [],
      lastSearchEmpty: false
    }
  }

  shouldSearch = () => {
    return this.state.searchTerm.length >= 2
  }

  search = async () => {
    const response = await api.get({ url: commodityCodeSearchPath(), params: { search: this.state.searchTerm } })
    if (response.status === 200) {
      const searchResults = response.data
      this.setState({
        searchResults,
        lastSearchEmpty: searchResults.length === 0
      })
    }
  }

  handleChange = async (event) => {
    this.setState({ searchTerm: event.target.value }, () => {
      if (this.shouldSearch()) {
        this.search()
      } else if (this.state.searchResults.length > 0) {
        this.setState({ searchResults: [] })
      }
    })
  }

  handleClear = () => {
    this.setState({
      searchTerm: '',
      searchResults: []
    })
  }

  renderTextWithBoldSearchTermMatches = (text) => {
    if (!this.state.searchTerm) { return }

    // Find instances of search term within string (regardless of whitespace)
    const regex = new RegExp(`(?<prematch>.*)(?<match>${this.state.searchTerm.replace(' ', '').split('').join('\\s*')})(?<postmatch>.*)`, 'i')
    const matchResults = text.match(regex)

    // If the search term appears within the item description, make it bold
    if (matchResults) {
      const { prematch, match, postmatch } = matchResults.groups
      return <>{prematch}<b>{match}</b>{postmatch}</>
    } else {
      return <>{text}</>
    }
  }

  renderSearchResult = ({ hierarchy, code, item_description: itemDescription }) => {
    let hierarchyTagText
    switch (hierarchy) {
      case 'commodity_class':
        hierarchyTagText = 'class'
        break
      default:
        hierarchyTagText = hierarchy
    }

    return (
      <div className='grid-x align-middle'>
        <div className='cell small-4'>
          <span className='search-result-metadata' aria-hidden>
            {this.renderTextWithBoldSearchTermMatches(`${hierarchyTagText} ${code}`)}
          </span>
        </div>
        <div className='cell auto'>
          <span className='search-result-description'>
            {this.renderTextWithBoldSearchTermMatches(itemDescription)}
          </span>
        </div>
        <div className='cell shrink align-right'>
          <i className='fas fa-chevron-right align-right' />
        </div>
      </div>
    )
  }

  renderSearchResults = (searchResults) => {
    if (searchResults.length > 0) {
      return (
        <ul>
          {
            searchResults.map((searchResult) => (
              <li
                tabIndex={0}
                className='search-result'
                onClick={() => this.props.handleSearchResultClick(searchResult)}
                key={searchResult.id}
              >
                {this.renderSearchResult(searchResult)}
              </li>
            ))
          }
        </ul>
      )
    } else if (this.state.lastSearchEmpty) {
      return (
        <div className='no-search-results-message'>
          No results found.
        </div>
      )
    }
  }

  render () {
    return (
      <div className='commodity-code-search-bar' role='search'>
        <div className='search-field'>
          <label htmlFor='commodity-code-search' aria-hidden='true'>
            <i className='fas fa-search align-self-middle' aria-hidden='true' />
          </label>
          <input
            type='text'
            name='search'
            id='commodity-code-search'
            value={this.state.searchTerm}
            aria-label='Commodity code search'
            placeholder='Search for codes by name or number to navigate'
            onChange={this.handleChange}
          />
          <button className='clear-button' onClick={this.handleClear} type='button' aria-label='Clear search input'>
            <i className='far fa-times' />
          </button>
        </div>

        {
          this.shouldSearch() && (
            <div className='search-results-select'>
              <h3>
                Searching UNSPSC
              </h3>
              {this.renderSearchResults(this.state.searchResults)}
            </div>
          )
        }
      </div>
    )
  }
}

SearchBar.propTypes = {
  handleSearchResultClick: PropTypes.func.isRequired
}
